import type { AdminPharmacist } from './types';

import { apiClient } from '~shared/api';

export const ROLES = {
  ADMINISTRATOR: 'Administrateur',
  PHARMACIST: 'Pharmacien',
  ASSISTANT: 'Préparateur',
  PHARMACIST_SUPPORT: 'Support Pharmacien',
  TECHNICAL_SUPPORT: 'Support Technique',
};

export const createPharmacist = ({
  pharmacyId,
  userName,
  email,
  firstName,
  lastName,
  role,
}: {
  pharmacyId: string;
  userName: string;
  email: string;
  firstName: string;
  lastName: string;
  role: string;
}): Promise<unknown> =>
  apiClient.post<unknown>(
    `/admin/valwin/pharmacies/${pharmacyId}/pharmacists`,
    { userName, email, firstName, lastName, role },
    { groupId: 'valwin' }
  );

export const getPharmacists = (
  pharmacyId: string
): Promise<AdminPharmacist[]> =>
  apiClient.get<AdminPharmacist[]>(
    `/admin/valwin/pharmacies/${pharmacyId}/pharmacists`,
    { groupId: 'valwin' }
  );

export const updatePharmacistRole = (
  pharmacyId: string,
  userName: string,
  role: string
): Promise<unknown> =>
  apiClient.put<unknown>(
    `/admin/valwin/pharmacies/${pharmacyId}/pharmacists/${userName}/role`,
    // apiClient sends strings as-is; the backend expects a JSON string
    JSON.stringify(role),
    { groupId: 'valwin' }
  );

export const activatePharmacist = (
  pharmacyId: string,
  userName: string
): Promise<unknown> =>
  apiClient.post<unknown>(
    `/admin/valwin/pharmacies/${pharmacyId}/pharmacists/${userName}/activate`,
    null,
    { groupId: 'valwin' }
  );
